import { CreateElement, Rect, SetStyles, Size } from "../.././MyHelpers";
import { MoneyFormatter } from "../../MoneyFormatter";
import { ImageResource } from "../../ResourceManager/ImageResource";
import { Resourceful, Resourceful2 } from "../../ResourceManager/Resourceful";
import { ResourceIdentifier } from "../../ResourceManager/ResourceIdentifier";
import { IReadOnlyResourceManager, IWriteOnlyResourceManager, LoadingStage, ResourceManager } from "../../ResourceManager/ResourceManager";
import { Settings } from "../../Settings";
import { TranslatedLocation, Translator } from "../../Translator";
import { ZIndex } from "../../ZIndex";
import { SlotBonus2 } from "../Bonus/SlotBonus2";
import { SlotBonusParams } from "../Bonus/SlotBonusParams";
import { PaytablePerSymbol } from "../Paytable/Paytable";
import { PickBonusMessages } from "../PickBonus/PickMessage";
import { BonusFinish, IBonusStartConfig } from "../SlotGame";
import { DiamondSpinConfiguration, IDiamondSpinResult } from "./DiamondSpin";
import { DiamondSpinJackpot } from "./DiamondSpinJackpot";
import { DiamondSpinMessages } from "./DiamondSpinMessages";
import { DiamondSpinSession } from "./DiamondSpinSession";

export interface DiamondSpinParams2 extends SlotBonusParams {
	readonly gameName: string;
	readonly gameBonusResourcesBasePath: string;
	readonly commonBonusResourcesBasePath: string
    readonly viewSize: Size;
	readonly bonusConfiguration: DiamondSpinConfiguration;
	readonly moneyFormatter: MoneyFormatter;
	readonly translator:Translator;

    
    // public constructor(
	// 	systemContext: ISystemContext,
	// 	gameName: string,
	// 	resid: ResourceIdentifier,
	// 	logGroup: LogGroup,
	// 	screenProtocol: ScreenProtocol,
	// 	screenProtocolScope: ScreenProtocolScope,
	// 	gameResourcesBasePath: string,
	// 	commonResourcesBasePath: string,
    //     viewSize: Size,
	// 	bonusConfiguration: DiamondSpinConfiguration,
	// 	moneyFormatter: MoneyFormatter,
	// 	translator:Translator,
	// ) {
	// 	super(systemContext, resid, logGroup, screenProtocol, screenProtocolScope);
	// 	this.gameName = gameName;
	// 	this.gameResourcesBasePath = gameResourcesBasePath;
	// 	this.commonResourcesBasePath = commonResourcesBasePath;
    //     this.viewSize = viewSize;
	// 	this.bonusConfiguration = bonusConfiguration;
	// 	this.moneyFormatter = moneyFormatter;
	// 	this.translator=translator;
	// }
}

export class DiamondSpin2 extends SlotBonus2 implements Resourceful2
{
	protected view: HTMLElement = null;
	protected override resid: ResourceIdentifier;
    protected parentresid: ResourceIdentifier = null;
	protected basepath: string = null;
	
	protected awardRect: Rect = null;
    
    protected params: DiamondSpinParams2 = null;
	protected gameBonusResourcesBasePath: string;
	protected commonBonusResourcesBasePath: string;
    protected viewSize: Size;
    
    protected moneyFormatter: MoneyFormatter = null;
    protected translator:Translator;
    
	//protected titleSprite: CanvasSprite = null;
	
	protected jp1Image:ImageResource = null;
	protected jp2Image:ImageResource = null;
	protected jp3Image:ImageResource = null;
	protected jp4Image:ImageResource = null;

    protected winContainer:HTMLElement = null;
    protected totalWinText: HTMLElement = null;
	protected winCount:HTMLElement= null;
	protected winBackground:HTMLElement = null;

	protected session: DiamondSpinSession = new DiamondSpinSession();
	//protected video: HTMLVideoElement = null;

	private paytable :PaytablePerSymbol[] = [];
	protected diamondSpiPaytable: DiamondSpinPaytable;
	
	protected diamondSpinWin: IDiamondSpinResult;
	protected diamondJackpots:Map<string,DiamondSpinJackpot> = new Map<string,DiamondSpinJackpot>();

	protected jackpotContainer: HTMLElement = null;

	protected BonusName(): string
	{
		return "DiamodSpin";
	} 
    
	constructor(gameResid: ResourceIdentifier, params: DiamondSpinParams2)
	{
        super(params.gameName, params);


        this.translator=params.translator;
		this.parentresid = gameResid;
		this.resid = gameResid.Add(this.bonusName + "2");

		this.params = params;
		this.gameBonusResourcesBasePath = params.gameBonusResourcesBasePath;
		this.commonBonusResourcesBasePath = params.commonBonusResourcesBasePath;
		this.viewSize = params.viewSize;

		this.basepath = Settings.ResourcesFolder + "../../slot/" + params.gameName + "/";

		this.view = document.createElement("div");
		this.view.classList.add(this.resid.Scope());
		this.view.style.position = "absolute";
		this.view.style.top = "0px";
		this.view.style.left = "0px";
		this.view.style.width = this.viewSize.Width + "px";
        this.view.style.height = this.viewSize.Height + "px";
        
        this.moneyFormatter = params.moneyFormatter;

		//this.screenProtocol.AddReceiveMessageHandler(DiamondSpinMessages.PrepareMessage.msgname, (m) => this.Prepare((<DiamondSpinMessages.PrepareMessage>m)), this.screenProtocolScope);
		this.screenProtocol.AddReceiveMessageHandler(DiamondSpinMessages.SpinComplete.msgname, (m) => this.SpinComplete((<DiamondSpinMessages.SpinComplete>m)), this.screenProtocolScope);

		this.screenProtocol.AddReceiveMessageHandler(DiamondSpinMessages.CommeteComplete.msgname, (m) => this.OnCommeteComplete((<DiamondSpinMessages.CommeteComplete>m)), this.screenProtocolScope);
		this.screenProtocol.AddReceiveMessageHandler(DiamondSpinMessages.CommetJPComplete.msgname, (m) => this.OnCometeJPComplete((<DiamondSpinMessages.CommetJPComplete>m)), this.screenProtocolScope);
		this.screenProtocol.AddReceiveMessageHandler(DiamondSpinMessages.JpShowFinish.msgname, (m) => this.JpOnShowFinished((<DiamondSpinMessages.JpShowFinish>m)), this.screenProtocolScope);
    }

    public async PrepareResources(loadingStage: LoadingStage, resourceManager: IWriteOnlyResourceManager): Promise<void>
    {
        resourceManager.Add(new ImageResource(this.params.commonBonusResourcesBasePath + "bonusWin.png", this.resid.ScopedResourceName(["bonusWin", "image"])));
		resourceManager.Add(new ImageResource(this.params.commonBonusResourcesBasePath + "frame.png", this.resid.ScopedResourceName(["frame", "image"])));


		for(let i = 0 ; i < this.params.bonusConfiguration.Constrains.RequiredJpToWin.length; i++)
		{
			let diamondJackpots:DiamondSpinJackpot = new DiamondSpinJackpot(this.params.bonusConfiguration.Constrains.RequiredJpToWin[i].Name,this.resid,this.params,this.params.bonusConfiguration.Constrains.RequiredJpToWin[i].RequiredToHit,i);
			this.diamondJackpots.set(this.params.bonusConfiguration.Constrains.RequiredJpToWin[i].Name, diamondJackpots);
		}

		
		this.diamondJackpots.forEach((jackpot:DiamondSpinJackpot)=>
		{
			jackpot.PrepareResources(resourceManager);
		});

		this.BasePrepare(resourceManager);
        console.log(this.params.commonBonusResourcesBasePath);
        this.TitlePrepare(resourceManager);
		
		//this.diamondSpiPaytable.PrepareResources(resourceManager);
    }

	protected BasePrepare(resourceManager: IWriteOnlyResourceManager): void
	{
		resourceManager.Add(new ImageResource(this.params.commonBonusResourcesBasePath + "sapphire.png", this.resid.ScopedResourceName(["jp1", "image"])));
		resourceManager.Add(new ImageResource(this.params.commonBonusResourcesBasePath + "emerald.png", this.resid.ScopedResourceName(["jp2", "image"])));
		resourceManager.Add(new ImageResource(this.params.commonBonusResourcesBasePath + "ruby.png", this.resid.ScopedResourceName(["jp3", "image"])));
		resourceManager.Add(new ImageResource(this.params.commonBonusResourcesBasePath + "diamond.png", this.resid.ScopedResourceName(["jp4", "image"])));
	}

	public BaseLoaded(resourceManager: IReadOnlyResourceManager):void
	{
		
		this.jp1Image = resourceManager.Get<ImageResource>(this.resid.ScopedResourceName(["jp1", "image"]));
		this.jp2Image = resourceManager.Get<ImageResource>(this.resid.ScopedResourceName(["jp2", "image"]));
		this.jp3Image = resourceManager.Get<ImageResource>(this.resid.ScopedResourceName(["jp3", "image"]));
		this.jp4Image = resourceManager.Get<ImageResource>(this.resid.ScopedResourceName(["jp4", "image"]));
	}

    protected PrepareWinContainer(resourceManager: IReadOnlyResourceManager):void
	{
		this.winContainer = document.createElement("div");
		this.winContainer.classList.add(this.resid.Scope());
		this.winContainer.classList.add("WinContainer");
		SetStyles(this.winContainer,
		{
			position : "absolute",
			top: "100px",
			left: "0px",
			width: "100%",
			height: "60%",
			display:"flex",
			flexDirection:"column",
			justifyContent:"center",
			alignItems:"center",
			zIndex:"3",
		});

		this.winCount = document.createElement("div");
		this.winCount.classList.add(this.resid.Scope());
		this.winCount.classList.add("WinCount");
		SetStyles(this.winCount,
		{
			height:"60%",
			width:"63%",
			display: "flex",
			justifyContent: "center",
			alignItems: "center",
			border: "40px solid transparent",
			zIndex: ""+ ZIndex.BonusWin,
			backgroundImage: resourceManager.Get<ImageResource>(this.resid.ScopedResourceName(["frame","image"])).CssBackground(),
			position:"absolute",
			backgroundRepeat:"no-repeat",
			backgroundSize:"contain",
			top:"145px",

		});

		this.totalWinText = document.createElement("div");
		this.totalWinText.classList.add(this.resid.Scope());
		this.totalWinText.classList.add("WinText");

		SetStyles(this.totalWinText,
		{
			height: "40%",
			width: "50%",
			fontSize: "80px",
			display: "flex",
			justifyContent: "center",
			alignItems: "center",
			top:"-100px",
			position:"absolute",


			backgroundImage:resourceManager.Get<ImageResource>(this.resid.ScopedResourceName(["bonusWin", "image"])).CssBackground(),
			backgroundRepeat: "no-repeat",
			backgroundSize: "contain",
			backgroundPosition:"center",
		});


		this.winBackground = document.createElement("div");
		this.winBackground.classList.add(this.resid.Scope());
		this.winBackground.classList.add("winBackground");
		SetStyles(this.winBackground,
		{
			width:"76%",
			height:"49%",
			backgroundColor:"rgba(0,0,0,0.5)",
			borderRadius:"70px",
			display: "flex",
			justifyContent: "center",
			alignItems: "center",
			fontSize: "120px",
			fontFamily: "NotoSansDisplay-Bold",
			color: "yellow",
			textShadow: "black 0px 0px 5px, black 0px 0px 15px, black 0px 0px 30px",
		});
		
		this.winCount.appendChild(this.winBackground);

		this.winContainer.appendChild(this.totalWinText);
		this.winContainer.appendChild(this.winCount);
		
		
		
	}

    public TitlePrepare(resourceManager: IWriteOnlyResourceManager) : void
	{
		//resourceManager.Add(new SpriteResource(this.params.commonBonusResourcesBasePath + "title", this.resid.Add("title"), true, this.logGroup.Add("title"), true));
    }
    
    public async ResourcesLoaded(loadingStage: LoadingStage, resourceManager: IReadOnlyResourceManager): Promise<void>
    {

		this.BaseLoaded(resourceManager);
		this.TitleLoaded(resourceManager);
		this.view.appendChild(this.winContainer);


		this.jackpotContainer = CreateElement("div", {classes:[this.resid.Scope(), "JackpotContainer"], parentToAppend:this.view,
			style:
			{
				position: "absolute",
				bottom: "0px",
				width : "100%",
				height : "25%",
				display : "flex",
				flexWrap : "wrap",
				justifyContent: "space-evenly",
				zIndex:"3",
			}
		});
		   
		this.diamondJackpots.forEach((jackpot:DiamondSpinJackpot)=>
		{
			jackpot.ResourcesLoaded(resourceManager);
			this.jackpotContainer.appendChild(jackpot.View());
        });

		//this.view.appendChild(this.paytableContainer);
		//this.diamondSpiPaytable.ResourcesLoaded(resourceManager);
		//this.view.appendChild(this.diamondSpiPaytable.View());
		this.PrepareWinContainer(resourceManager);
	}

    public TitleLoaded(resourceManager: IReadOnlyResourceManager)
	{
		// let sprite = Sprite.Create(
		// 	resourceManager.Get<ImageResource>(this.resid.ScopedResourceName(["title", "image"])).img,
		// 	resourceManager.Get<JSONResource>(this.resid.ScopedResourceName(["title", "json"])).json,
		// );
		// this.titleSprite = new CanvasSprite(sprite, new Size(1920,400));

		// this.view.appendChild(this.titleSprite.View());

		//this.titleSprite.Start(false);

		/* this.titleSprite.AddOnCompleteCallback(()=> setTimeout(()=>
			this.titleSprite.Start(false)
		,5000)); */
	}

	public OnBonusFinish(bonusFinish: BonusFinish): void
	{
		
    }
    public Prepare(bonusStartConfig: IBonusStartConfig): void {
        
    }
    public Hide(): void 
    {
        this.view.style.visibility = "hidden";   
    }
    public Show(): void 
    {
        this.view.style.visibility = "visible";   
    }
    public Update(): void
    {
        //this.titleSprite.Update();
    }
    public View(): HTMLElement {
        return this.view;
    }
    public Start(): void
    {
        this.session.Reset();
		this.Reset();

		//this.awardRect = new PixelRect(555,400,800,200);
        
    }
	public Stop(): void 
	{
    }
    public Reset(): void {
		this.winBackground.innerHTML = ""+ this.moneyFormatter.FormatCurrency(this.session.totalWin);
		//this.awardRect = null;
		
		this.diamondJackpots.forEach((jackpot:DiamondSpinJackpot)=>
		{
			for(let i = 0; i < jackpot.WinContainer().length; i++)
			{
				jackpot.WinContainer()[i].style.backgroundImage = "none";
			}
		});

		//this.bonusStartConfig = null;

		this.allAwardRect = [];
	}
	
	protected allAwardRect: Rect[] = [];
	private SpinComplete(message: DiamondSpinMessages.SpinComplete): void
	{
		this.jpHitIndex = 0;
		this.allAwardRect = [];
		this.diamondSpinWin = message.diamondSpinWin;

		for(let i = 0; i < this.diamondSpinWin.ReelJp.length; i++)
		{
			let jp: string = this.diamondSpinWin.ReelJp[i].Name;
			let jpCount: number = this.diamondSpinWin.ReelJp[i].Count;
			let currentJackpot:DiamondSpinJackpot = this.diamondJackpots.get(jp);
			let awardRect: Rect = currentJackpot.CenterOfFreeSpaceForDiamond(jpCount);
			this.allAwardRect.push(awardRect);
		} 
		
		this.screenProtocol.Send(new DiamondSpinMessages.CommetDestination(this.allAwardRect),this.screenProtocolScope);
	}
	
	protected lastJp: string = "";
	private OnCommeteComplete(message:DiamondSpinMessages.CommeteComplete): void
	{
		let jp: string = this.diamondSpinWin.ReelJp[message.reel].Name;
		let jpCount: number = this.diamondSpinWin.ReelJp[message.reel].Count;
		let currentJackpot:DiamondSpinJackpot = this.diamondJackpots.get(jp);
		let freeSpotForJackpot = currentJackpot.JpFreeSpot(jpCount);

		
		this.AddJp(jp, jpCount);
		if(freeSpotForJackpot < currentJackpot.WinContainer().length)
		{
			if(jp == "jp1")
			{
				if(jpCount == this.params.bonusConfiguration.Constrains.RequiredJpToWin[0].RequiredToHit)
				{
					// from 3. screen jackpot to bonus won box on 2. screen
					this.screenProtocol.Send(new DiamondSpinMessages.CommetJp(new Rect(1094,917,601,114),new Rect(480,480,850,200)),this.screenProtocolScope);
				}
			}
			else if(jp == "jp2")
			{
				if(jpCount == this.params.bonusConfiguration.Constrains.RequiredJpToWin[1].RequiredToHit)
				{
					// from 3. screen jackpot to bonus won box on 2. screen
					this.screenProtocol.Send(new DiamondSpinMessages.CommetJp(new Rect(1094,717,601,114),new Rect(480,480,850,200)),this.screenProtocolScope);
				}
			}
			else if(jp == "jp3")
			{
				if(jpCount == this.params.bonusConfiguration.Constrains.RequiredJpToWin[2].RequiredToHit)
				{
					// from 3. screen jackpot to bonus won box on 2. screen
					this.screenProtocol.Send(new DiamondSpinMessages.CommetJp(new Rect(1094,417,601,114),new Rect(480,480,850,200)),this.screenProtocolScope);
				}
			}
			else if(jp == "jp4")
			{
				if(jpCount == this.params.bonusConfiguration.Constrains.RequiredJpToWin[3].RequiredToHit)
				{
					// from 3. screen jackpot to bonus won box on 2. screen
					this.screenProtocol.Send(new DiamondSpinMessages.CommetJp(new Rect(1094,250,601,114),new Rect(480,480,850,200)),this.screenProtocolScope);
				}
			}
		}
	}

	protected AddJp(jpName:string, count:number)
	{
		let currentJackpot:DiamondSpinJackpot = this.diamondJackpots.get(jpName);
		this.lastJp = jpName;
			//let destRect = currentJackpot.CenterOfFreeSpaceForDiamond(this.award);
			let freeSpotForJackpot = currentJackpot.JpFreeSpot(count);
		
			if(freeSpotForJackpot < currentJackpot.WinContainer().length)
			{
				if(jpName == "jp1")
				{
					currentJackpot.WinContainer()[freeSpotForJackpot].style.backgroundImage = this.jp1Image.CssBackground();
				}
				else if(jpName == "jp2")
				{
					currentJackpot.WinContainer()[freeSpotForJackpot].style.backgroundImage = this.jp2Image.CssBackground();
				}
				else if(jpName == "jp3")
				{
					currentJackpot.WinContainer()[freeSpotForJackpot].style.backgroundImage = this.jp3Image.CssBackground();
				}
				else if(jpName == "jp4")
				{
					currentJackpot.WinContainer()[freeSpotForJackpot].style.backgroundImage = this.jp4Image.CssBackground();
				}
				else
				{
					throw new Error("Unknown jackpot "+ jpName);
				}	
			} 
	}
	
	protected jpHitIndex:number = 0;
	protected OnCometeJPComplete(message:DiamondSpinMessages.CommetJPComplete)
	{	
		//let hittedJP = this.diamondJackpots.get(this.lastJp);

		this.session.totalWin += this.diamondSpinWin.HittedJp[this.jpHitIndex].JpHit.InCents;
		this.jpHitIndex ++;
		
		this.winBackground.innerHTML = ""+ this.moneyFormatter.FormatCurrency(this.session.totalWin);
		//this.titleSprite.Start(false);		
		
		
		// for(let i = 0; i < hittedJP.WinContainer().length; i++)
		// {
		// 	hittedJP.WinContainer()[i].style.backgroundImage = "none";
		// }
	}

	protected JpOnShowFinished(message:PickBonusMessages.JpShowFinish)
	{
		//reset only hite JP
		let hittedJP = this.diamondJackpots.get(this.lastJp);

		for(let i = 0; i < hittedJP.WinContainer().length; i++)
		{
			hittedJP.WinContainer()[i].style.backgroundImage = "none";
		}
			
	}


	
	
	/* private UpdatePaytable(message:DiamondSpinMessages.CurrentBet): void
	{
		let bet: number = message.bet;
		this.diamondSpiPaytable.Update(bet);
	} */
}


export interface IDiamondSpinFactory2
{
    CreateDiamondSpin2(gameName: ResourceIdentifier, params: DiamondSpinParams2): DiamondSpin2
}

export class DiamondSpinFactory2 implements IDiamondSpinFactory2
{
    public CreateDiamondSpin2(gameName: ResourceIdentifier, params:DiamondSpinParams2): DiamondSpin2
    {
        return new DiamondSpin2(gameName, params);
    }
}




export class DiamondSpinPaytable implements Resourceful
{
	
	protected paytable: PaytablePerSymbol[] = [];
	protected view:HTMLElement = null;
	protected jpWin: HTMLElement = null;
	protected brickForProggresive: HTMLElement = null;

	//protected reelpPay: HTMLElement = null;
	//protected brickPay: HTMLSpanElement = null;

	protected oneJpWin: HTMLElement = null;

	protected resid: ResourceIdentifier;
	protected parentresid: ResourceIdentifier = null;
	protected path: string = "";

	protected JPName:string[] = [];

	protected translator: Translator;

	protected moneyFormatter: MoneyFormatter ;

	constructor(paytable: PaytablePerSymbol[], resid: ResourceIdentifier, path: string, translator: Translator, moneyFormatter: MoneyFormatter)
	{
		this.paytable = paytable;
		this.parentresid = resid;
		this.resid = resid.Add("DiamondSpinPaytable");
		this.path = path;
		this.translator = translator;
		this.moneyFormatter = moneyFormatter;
	}

	PrepareResources(resourceManager: ResourceManager) 
	{
		resourceManager.Add(new ImageResource(this.path + "paytable/graphite.png", this.resid.ScopedResourceName(["graphite", "image"])));
		resourceManager.Add(new ImageResource(this.path + "paytable/bronze.png", this.resid.ScopedResourceName(["bronze", "image"])));
		resourceManager.Add(new ImageResource(this.path + "paytable/silver.png", this.resid.ScopedResourceName(["silver", "image"])));
		resourceManager.Add(new ImageResource(this.path + "paytable/gold.png", this.resid.ScopedResourceName(["gold", "image"])));


		resourceManager.Add(new ImageResource(this.path + "paytable/blue.png", this.resid.ScopedResourceName(["jp1", "image"])));
		resourceManager.Add(new ImageResource(this.path + "paytable/green.png", this.resid.ScopedResourceName(["jp2", "image"])));
		resourceManager.Add(new ImageResource(this.path + "paytable/red.png", this.resid.ScopedResourceName(["jp3", "image"])));
		resourceManager.Add(new ImageResource(this.path + "paytable/white.png", this.resid.ScopedResourceName(["jp4", "image"])));


	}

	ResourcesLoaded(resourceManager: IReadOnlyResourceManager) 
	{

		this.view = document.createElement("div");
		this.view.classList.add("Diamond-spin-paytable");

		this.JPName.push("jp4");
		this.JPName.push("jp3");
		this.JPName.push("jp2");
		this.JPName.push("jp1");


		this.CreatePaytable(this.paytable, resourceManager);
	}

	private CreatePaytable(paytable: PaytablePerSymbol[], resourceManager: IReadOnlyResourceManager): void
	{
		

		SetStyles(this.view,
		{
			position:"absolute",
			bottom:"25px",
			width:"100%",
			height:"30%",
			display:"flex",
			justifyContent:"space-evenly",
		});

		// jp win conditions on paytable view
		this.jpWin = document.createElement("div");
		this.jpWin.classList.add("jpHit");
		SetStyles(this.jpWin,
		{
			width:"45%",
			height:"100%",
			backgroundColor:"rgba(0,0,0,0.5)",
			borderRadius:"25px",
			display:"flex",
			flexDirection:"column-reverse",
		});


		// left side 
		for(let i = 0; i < this.paytable.length; i++)
		{
			let progresiveView = document.createElement("div");
			progresiveView.classList.add("progresiveView",""+i);

			let jp = document.createElement("div");
			jp.classList.add(""+i);
			let jpName:string = this.JPName[i];

			SetStyles(jp,
			{
				width:"10%",
				height:"100%",
				backgroundImage: resourceManager.Get<ImageResource>(this.resid.ScopedResourceName([jpName, "image"])).CssBackground(),
				backgroundRepeat:"no-repeat",
				backgroundSize:"contain",
			});

			SetStyles(progresiveView,
			{
				width:"100%",
				height:"25%",
				display:"flex",
				color:"yellow",
				fontSize:"40px",
				fontFamily:"NotoSansDisplay-Bold",
			});

			for(let j = 0; j < 3; j++)
			{
				this.brickForProggresive = document.createElement("div");
				this.brickForProggresive.classList.add(""+j);
				let brick: string = paytable[i].Symbol.ID;

				SetStyles(this.brickForProggresive,
				{
					width:"10%",
					height:"100%",
					backgroundImage: resourceManager.Get<ImageResource>(this.resid.ScopedResourceName([brick, "image"])).CssBackground(),
					backgroundRepeat:"no-repeat",
					backgroundSize:"contain",
				});
				progresiveView.innerHTML += this.brickForProggresive.outerHTML;
			}
			progresiveView.innerHTML += 'WIN &nbsp;';
			progresiveView.innerHTML += jp.outerHTML;
			progresiveView.innerHTML += "JACKPOT";
			this.jpWin.appendChild(progresiveView);
		}

		this.oneJpWin = document.createElement("div");
		this.oneJpWin.classList.add("oneJpWin");
		SetStyles(this.oneJpWin,
		{
			width:"45%",
			height:"100%",
			backgroundColor:"rgba(0.0.0.0,5)",
			borderRadius:"25px",
			display:"flex",
			flexDirection:"column-reverse",
		});

		// right side 
		for(let i = 0; i < this.paytable.length; i++)
		{
			
			let brick: string = paytable[i].Symbol.ID;
			let wincredits: number = paytable[i].Combinations[0].WinCredits;
			
			let reelpPay: HTMLElement = document.createElement("div");
			reelpPay.classList.add("reelpPay");

			SetStyles(reelpPay,
			{
				display:"flex",
				width:"100%",
				height:"25%",
				color:"yellow",
				fontSize:"40px",
				fontFamily:"NotoSansDisplay-Bold",
			});

			let brickPay: HTMLSpanElement = document.createElement("span");
			brickPay.classList.add("brickPay");
			SetStyles(brickPay,
			{
				width:"90px",
				height:"100px",
				display:"inline-block",
				verticalAlign: "middle",
				backgroundImage: resourceManager.Get<ImageResource>(this.resid.ScopedResourceName([brick, "image"])).CssBackground(),
				backgroundRepeat:"no-repeat",
				backgroundSize:"contain",
			});

			let award:HTMLSpanElement = document.createElement("span");
			award.classList.add("wincredits");
			award.innerHTML = ""+wincredits;

			/* this.reelpPay.innerHTML += "EVERY ONE OF &nbsp;";
			this.reelpPay.appendChild(this.brickPay);
			//this.reelpPay.innerHTML += `&nbsp; PAYS <span class"multiplyer">${multiplyer}</span> CREDITS`;
			this.reelpPay.innerHTML += `&nbsp; PAYS &nbsp;`;
			this.reelpPay.appendChild(award);
			this.reelpPay.innerHTML += `&nbsp; CREDITS`; */

			//this.spinPaytable = this.translator.Translate(() => this.translator.t.diamondspinPayTable(this.gold.outerHTML,this.silver.outerHTML,this.bronze.outerHTML,this.graphite.outerHTML));
			let spinPaytable: TranslatedLocation = this.translator.Translate(() => this.translator.t.diamondspinPayTable(brickPay.outerHTML,award.outerHTML));

			reelpPay.appendChild(spinPaytable.location);
			this.oneJpWin.appendChild(reelpPay);
		}
		this.view.appendChild(this.jpWin);
		this.view.appendChild(this.oneJpWin);
	}

	public Update(betCents: number):void
	{
		let multi = this.oneJpWin.querySelectorAll(".wincredits");

		for(let i = 0; i< this.paytable.length; i++)
		{
			let a:number = betCents * this.paytable[i].Combinations[0].WinCredits;
			multi[i].innerHTML = ""+ this.moneyFormatter.FormatCurrency(a);
		}
	}

	public View(): HTMLElement
	{
		return this.view;
	}
}